var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"requestError"},[_c('div',{staticClass:"requestError-box"},[_c('img',{staticClass:"box-img",attrs:{"src":require("@/assets/image/requestError.png"),"alt":"loading"}}),_c('h2',{staticClass:"box-h2"},[_vm._v("請求失敗，請重新整理頁面。")]),_c('h5',{staticClass:"box-h5"},[_vm._v("Request failed, please refresh the page.")])])])
}]

export { render, staticRenderFns }